import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./Homepage1.css";
import Navbar from "./Navbar/Navbar";
import HeroSection from "./Hero/HeroSection";
import ProductSuiteSection from "./ProductSuite/ProductSuiteSection";
import ArchitectureSection from "./Architecture/ArchitectureSection";
import CommunitySection from "./Community/CommunitySection";
import Footer from "./Footer/Footer";

export const Homepage1: React.FC = () => {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage1-root">
      <Helmet>
        <title>indexx.ai — The Unified Ecosystem of AI &amp; Crypto</title>
        <meta
          name="description"
          content="indexx.ai connects predictive machine intelligence with modular decentralized finance across an interconnected suite of native platforms."
        />
        <meta property="og:title" content="indexx.ai — The Unified Ecosystem of AI & Crypto" />
        <meta
          property="og:description"
          content="Explore the indexx.ai ecosystem: interconnected platforms spanning AI agents, spot and DEX trading, synthetic Wall Street finance, and stable settlement."
        />
      </Helmet>

      {/* Subtle Ambient Neutral Shading Background */}
      <div className="homepage1-ambient-glow">
        <div className="homepage1-ambient-blob" />
      </div>

      {/* Floating Top Navbar with Google-Style 9-Dots Launcher */}
      <Navbar />

      {/* Main Content Area */}
      <main className="homepage1-main">
        {/* Hero Section */}
        <HeroSection />

        {/* Product Suite Section */}
        <ProductSuiteSection />

        {/* Architecture Foundation (3-Pillar) */}
        <ArchitectureSection />

        {/* Ecosystem Guild & Community */}
        <CommunitySection />
      </main>

      {/* Footer & Directory */}
      <Footer />
    </div>
  );
};

export default Homepage1;
